import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {getPublicFile} from 'helpers/envHelper'
import styled from 'styled-components'
import useHealthCenterBrainFunctionMappingStyles from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Style'
import TableFiguresByPart from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Elements/tableFiguresByPart'
import useLangEn from 'hooks/useLangEn'
import {useAppSelector} from 'hooks'
import {
  getCurrentLanguageReport,
  selectLanguageReport,
} from 'features/languageReport/languageReportSlice'

export const PageWrap = styled.div`
  background: White;
`

export const PageContent = styled.div`
  width: 1160px;
`

export const CardContent = styled.div`
  font-size: 14px;
`

export const FlexBox = styled.div`
  display: flex;
  padding: 0 15px;
  justify-content: space-between;
`
const getHealthReportReportImage = getPublicFile('images/health_center_report')

interface BrainFunctionMappingProps {
  agingRoiScore: Record<string, any>
}

const getNumber = (value: number | string) => {
  if (!Number.isNaN(Number(value))) return Math.floor(Number(value))
  return 0
}

function TablePrintT6({agingRoiScore}: BrainFunctionMappingProps) {
  const {t} = useTranslation()
  const classes = useHealthCenterBrainFunctionMappingStyles()
  const isEn = useLangEn()
  const languageReport = useAppSelector((state) =>
    selectLanguageReport(state.languageReport),
  )
  const currentLanguagueReport = getCurrentLanguageReport(languageReport, 'es')
  const headTable = [
    currentLanguagueReport?.health?.brain_mapping.advanced.section.parietal
      .score_table.headers[0] || '',
    currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
      .score_table.headers[1] || '',
    currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
      .score_table.headers[2] || '',
    currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
      .score_table.headers[3] || '',
    currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
      .score_table.headers[4] || '',
  ]

  const bodyTable4 = useMemo(
    () => [
      {
        data: [
          {
            header: [
              {
                // key: 'T6.',
                // content: 'Banks of Superior Temporal Sulcus',
                // note: t('ISuperiorT6'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[5].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .temporal.score_table.rows[5].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[5].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainT6.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[5].functions,
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[5].symptoms,

          [getNumber(agingRoiScore?.Banks_of_Superior_Temporal_Sulcus_LH)],
          [getNumber(agingRoiScore?.Banks_of_Superior_Temporal_Sulcus_RH)],
        ],
        background: 'White',
      },
      {
        data: [
          {
            header: [
              {
                // key: 'T7.',
                // content: 'Fusiform',
                // note: t('INoteT7'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[6].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .temporal.score_table.rows[6].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[6].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainT7.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[6].functions,
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[6].symptoms,

          [getNumber(agingRoiScore?.Fusiform_LH)],
          [getNumber(agingRoiScore?.Fusiform_RH)],
        ],
        background: 'White',
      },
      {
        data: [
          {
            header: [
              {
                // key: 'T8.',
                // content: 'Entorhinal',
                // note: t('ICortexT8'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[7].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .temporal.score_table.rows[7].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[7].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainT8.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[7].functions,
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[7].symptoms,
          [getNumber(agingRoiScore?.Entorhinal_LH)],
          [getNumber(agingRoiScore?.Entorhinal_RH)],
        ],
        background: 'White',
      },
      {
        data: [
          {
            header: [
              {
                // key: 'T9.',
                // content: 'Parahippocampal',
                // note: t('IHippocampusT9'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[8].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .temporal.score_table.rows[8].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[8].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainT9.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[8].functions || [],
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[8].symptoms || [],

          [getNumber(agingRoiScore?.Parahippocampal_LH)],
          [getNumber(agingRoiScore?.Parahippocampal_RH)],
        ],
        background: 'White',
      },
      {
        data: [
          {
            header: [
              {
                // key: 'T10.',
                // content: 'Insula',
                // note: t('IInsulaT10'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[9].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .temporal.score_table.rows[9].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.temporal.score_table.rows[9].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainT10.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[9].functions,
          currentLanguagueReport?.health?.brain_mapping.advanced.section
            .temporal.score_table.rows[9].symptoms,
          [getNumber(agingRoiScore?.Insula_LH)],
          [getNumber(agingRoiScore?.Insula_RH)],
        ],
        background: 'White',
      },
    ],
    [isEn, currentLanguagueReport],
  )

  return (
    <div className={classes.brainFunctionMapping}>
      <PageWrap>
        <PageContent>
          <div className={classes.marginBottom60}>
            <TableFiguresByPart
              head={headTable}
              body={bodyTable4 as any}
              isLocalLanguage={false}
            />
          </div>
        </PageContent>
      </PageWrap>
    </div>
  )
}

export default TablePrintT6
